<template>

  <table class="table table-borderless table-border table-align table-h51">
    <thead>
      <tr>
        <th></th>
        <th>Razão Social</th>
        <th>CNPJ</th>
        <th v-if="company.type === 'provider'">Tipo</th>
        <th>UF</th>
        <th>IE</th>
        <th>IM</th>
        <th>Criado por</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="associate_company in companies" :key="associate_company.id">
        <td>
          <BkpsCheckBox v-model="associate_company.checked" @input="$emit('checked', associate_company)"/>
        </td>
        <td>{{ associate_company.name | uppercase }}</td>
        <td>{{ associate_company.cnpj | cnpj }}</td>
        <td v-if="company.type === 'provider'">
          {{ `company.${associate_company.type}` | t }}
        </td>
        <td>{{ associate_company.uf }}</td>
        <td>{{ associate_company.ie }}</td>
        <td>{{ associate_company.im }}</td>
        <td>{{ associate_company.createdBy }}</td>
      </tr>
    </tbody>
  </table>

</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

  export default {
    components: { BkpsCheckBox },
    name: 'TableProviderCompany',
    props: {
      companies: { required: true, type: Array },
      company: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>
